//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchUpdate, fetchDetail, fetchCustomerList } from '@/api/PMS/baseInformation/pakinglotoa';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      loading: false,
      customerList: [],
      childData: {},
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.childData = {};
      this.customerList = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;

          _this.getCustomerList();

          delete _this.childData.customerName;
          delete _this.childData.garageName;
          delete _this.childData.isLeaseName;
          delete _this.childData.parkingTypeName;
        });
      } else {
        this.childData = {};
      }
    },
    getCustomerList: function getCustomerList(query) {
      var _this2 = this;

      query = query || '';
      var queryData = {
        name: query,
        id: this.childData.areaGroupId
      };
      fetchCustomerList(queryData).then(function (r) {
        _this2.loading = false;
        _this2.customerList = r.data.data;
      });
    },
    handUpdate: function handUpdate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function () {
              _this3.$emit('handCancle', true);

              _this3.Alert({
                alertType: 'update'
              });
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'binding');
    }
  }
};